export default __webpack_public_path__ + "media/images/52-2e191603d9cf6ac52b04789387b7de3a.png";